module.exports = __webpack_public_path__ + "JatinPandey-16901610.webp";